function toDate(d: string | Date): Date {
  return typeof d === 'string' ? /^\d{4}-\d{2}-\d{2}$/.test(d) ? new Date(`${d}T00:00:00`) : new Date(d) : d;
}

/** DD/MM/YYYY, local time. Null/invalid → '—'. */
export function fmtDate(d: string | Date | null | undefined): string {
  if (!d) return '—';
  const dt = toDate(d);
  if (Number.isNaN(dt.getTime())) return '—';
  const dd = String(dt.getDate()).padStart(2, '0');
  const mm = String(dt.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${String(dt.getFullYear()).padStart(4, '0')}`;
}

/** DD/MM/YYYY HH:MM (24h), local time. Null/invalid → '—'. */
export function fmtDateTime(d: string | Date | null | undefined): string {
  if (!d) return '—';
  const dt = toDate(d);
  if (Number.isNaN(dt.getTime())) return '—';
  const hh = String(dt.getHours()).padStart(2, '0');
  const mi = String(dt.getMinutes()).padStart(2, '0');
  return `${fmtDate(dt)} ${hh}:${mi}`;
}

/** Whole calendar days from today (local midnight) to `d`; negative = past. */
export function daysUntil(d: string | Date): number {
  const dt = toDate(d);
  const day = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((day.getTime() - today.getTime()) / 86_400_000);
}

/** Documents Phase 3 expiry badge tone: green >21d, amber ≤21d, red ≤7d or expired. */
export type ExpiryTone = 'green' | 'amber' | 'red';
export function expiryTone(d: string | Date | null | undefined): ExpiryTone | null {
  if (!d) return null;
  const dt = toDate(d);
  if (Number.isNaN(dt.getTime())) return null;
  const days = daysUntil(dt);
  return days <= 7 ? 'red' : days <= 21 ? 'amber' : 'green';
}
